import { useParams } from 'react-router'
import { staticPages } from '../data'
import { NotFoundPage } from './NotFoundPage'

export function StaticPage() {
  const { pageSlug } = useParams()
  const page = staticPages.find(({ slug }) => slug === pageSlug)

  if (!page) return <NotFoundPage />

  return (
    <section className="content-page">
      <div className="legacy-page-title">
        <div className="inner-shell">
          <p>{page.eyebrow}</p>
          <h1>{page.name}</h1>
        </div>
      </div>
      <div className="inner-shell content-page__body">
        <p className="lead">{page.summary}</p>

      </div>
    </section>
  )
}
